<template>
    <div class="header-dropdown">
        <a class="header-dropdown-profile"
            @click="dropdown = !dropdown">

            <!-- THIS IS AVATAR IMAGE -->
            <vh-avatar
                :active="true"
                :size="'small'"
                :src="accessUser.photo"
                :label="accessUser.full_name[0]"
            />

            <!-- THIS IS NAME WITH ROLE NAME -->
            <div class="header-dropdown-name">
                <p class="vh-text-bold vh-margin-remove">{{accessUser.full_name}}</p>
            </div>
        </a>

        <!-- THIS IS DROPDOWN MENU -->
        <ul
            class="header-dropdown-menu vh-box-shadow-small"
            :class="{ 'header-dropdown-menu-open': dropdown }">
            <li><router-link to="/my-account"><span>My Account</span></router-link></li>
            <li><a class="vh-link-reset" @click="openModal('logout')"><span>Logout</span></a></li>
            <hr>
            <div class="vh-text-center"><small style="font-size: 9px;">{{appVersion}}</small></div>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default
{
    name: 'Account',
    
    data()
    {
        return {
            dropdown: false,
        };
    },

    mounted()
    {
        window.addEventListener('click', this.clickOutside);
    },

    computed:
    {
        ...mapGetters({
            accessUser: 'auth/accessUser',
        }),

        appVersion()
        {
            return process.env.VUE_APP_VERSION;
        },
    },

    methods:
    {
        openModal(name)
        {
            this.$parent.toggleModal(name, true);
        },

        clickOutside(event)
        {
            if (!this.$el.contains(event.target))
            {
                this.dropdown = false;
            }
        },
    },
};
</script>